import {SET_AUTH_CODE, SET_LOGIN_STATE, SET_USER_INFO} from "./mutation-types";
import { delCookie } from "@/utils/cookieUtils";

const app = {
  // 全局状态
  state: {
    // 用户信息
    userInfo: {},
    // 用户权限
    authCode: {},
    isLogin: false,
  },
  // getters是对数据的包装，例如对数据进行拼接，或者过滤
  getters: {
    //类似于计算属性
    getUserPhoto(state) {
      if (state.isLogin) {
        if (state.userInfo.photoUrl) {
          // 验证photoUrl是否为有效的头像URL
          const photoUrl = state.userInfo.photoUrl;

          // 过滤掉明显的非头像URL
          if (photoUrl.includes('favicon.png') ||
              photoUrl.includes('defaultAvatar.png') ||
              photoUrl.includes('default.png') ||
              photoUrl.includes('cube.elemecdn.com')) {
            return "https://file.itgetjob.com:15090/rootfile/1742378549034.png";
          }

          return photoUrl;
        } else {
          return "https://file.itgetjob.com:15090/rootfile/1742378549034.png";
        }
      } else {
        return "https://file.itgetjob.com:15090/rootfile/1742378549034.png";
      }
    }
  },
  // 如果我们需要更改store中的状态，一定要通过mutations来进行操作
  mutations: {

    // 传入自定义参数
    [SET_USER_INFO](state, userInfo) {
      state.userInfo = userInfo;
    },
    [SET_LOGIN_STATE](state, isLogin) {
      state.isLogin = isLogin;
    },
    [SET_AUTH_CODE](state, authCode) {
      state.authCode = authCode;
    }
  },

  // actions是我们定义的一些操作，正常情况下，我们很少会直接调用mutation方法来改变state
  actions: {
    // 登出处理
    logout({ commit }) {
      commit(SET_LOGIN_STATE, false);
      commit(SET_USER_INFO, {});
      commit(SET_AUTH_CODE, {});
      // Cookie清除
      delCookie('token');
    }
  }
}
export default app



// WEBPACK FOOTER //
// ./src/store/user.js